import { INITIAL_SAVE_REQUEST_META } from '../utils';
import { NotificationsWidgetData } from './types';

const defaultNotificationsWidgetData: NonNullable<{
  deviantart: NonNullable<NotificationsWidgetData['initialData']['deviantart']>;
  email: NonNullable<NotificationsWidgetData['initialData']['email']>;
}> = {
  deviantart: {
    mentions: false,
    badges: false,
    deviantartProtect: false,
    newMembers: false,
  },
  email: {
    accountActivity: false,
    news: false,
    passwordReset: false,
    otp: '',
  },
};

export const defaultNotificationsWidgetState: NotificationsWidgetData = {
  initialData: defaultNotificationsWidgetData,
  currentData: defaultNotificationsWidgetData,
  isDirty: false,
  saveRequest: INITIAL_SAVE_REQUEST_META,
};
